import { computed, inject, provide, reactive } from 'vue'

const pageGuideKey = Symbol('pageGuide')

export const providePageGuide = () => {
  const route = useRoute()
  const entries = reactive(new Map())
  const sections = computed(() => {
    const unique = new Map()
    for (const entry of entries.values()) {
      if (entry.path !== route.path || !entry.text) continue
      const key = `${entry.title}:${entry.text}`
      if (!unique.has(key)) unique.set(key, entry)
    }
    return [...unique.values()]
  })
  const guide = {
    sections,
    set(id, entry) {
      const previous = entries.get(id)
      if (previous?.path === entry.path && previous?.title === entry.title && previous?.text === entry.text) return
      entries.set(id, entry)
    },
    remove: id => entries.delete(id),
  }
  provide(pageGuideKey, guide)
  return guide
}

export const usePageGuide = () => inject(pageGuideKey, null)
